import { useState } from 'react'
import { useBrandColors } from '../../hooks/useBrandColors'

export default function Timesheets() {
  const { accent, accentLight, accentBg } = useBrandColors()
  const [submitted, setSubmitted] = useState(false)

  const days = [
    { name: 'Sun', date: '30', off: true },
    { name: 'Mon', date: '31', clockIn: '08:00', clockOut: '16:30', hours: 8.0 },
    { name: 'Tue', date: '1',  clockIn: '07:30', clockOut: '16:30', hours: 8.5 },
    { name: 'Wed', date: '2',  clockIn: '08:00', clockOut: '16:30', hours: 8.0 },
    { name: 'Thu', date: '3',  clockIn: '',      clockOut: '',      hours: 0   },
    { name: 'Fri', date: '4',  clockIn: '',      clockOut: '',      hours: 0   },
    { name: 'Sat', date: '5',  off: true },
  ]

  const total = days.reduce((sum, d) => sum + (d.hours || 0), 0)
  const overtime = Math.max(0, total - 40)
  const regular = Math.min(total, 40)

  return (
    <div style={{fontFamily:"'Montserrat',sans-serif"}}>
      <div style={{marginBottom:20,display:'flex',alignItems:'center',justifyContent:'space-between'}}>
        <div>
          <h1 style={{fontFamily:'Georgia,serif',fontSize:'1.4rem',color:'#2B2B2B',fontWeight:600}}>Timesheets</h1>
          <p style={{fontSize:11,color:'#6B7D6B',marginTop:2}}>Submit your weekly hours for manager approval</p>
        </div>
      </div>

      {/* Stats */}
      <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:10,marginBottom:20}}>
        {[
          {label:'This Week', value:total.toFixed(1), pill:'In progress', pillColor:accent},
          {label:'Last Week', value:'40.0', pill:'Approved', pillColor:'#4A7C59'},
          {label:'Overtime YTD', value:'6.5', pill:'Tracked', pillColor:'#4A6B8A'},
          {label:'Status', value:submitted?'Submitted':'Draft', pill:submitted?'Awaiting approval':'Not submitted', pillColor:submitted?'#C4843A':accent},
        ].map(s => (
          <div key={s.label} style={{background:'#fff',border:'1px solid #EDE6DA',borderRadius:10,padding:'14px 16px'}}>
            <div style={{fontSize:9,textTransform:'uppercase',letterSpacing:'0.1em',color:'#6B7D6B',fontWeight:500,marginBottom:4}}>{s.label}</div>
            <div style={{fontFamily:'Georgia,serif',fontSize:'1.5rem',color:'#2B2B2B',fontWeight:600,lineHeight:1}}>{s.value}</div>
            <div style={{marginTop:4,display:'inline-block',padding:'1px 6px',borderRadius:8,fontSize:10,fontWeight:600,background:s.pillColor+'22',color:s.pillColor}}>{s.pill}</div>
          </div>
        ))}
      </div>

      {submitted && (
        <div style={{display:'flex',alignItems:'center',gap:8,background:'rgba(74,124,89,0.1)',border:'1px solid #4A7C59',borderRadius:8,padding:'10px 14px',marginBottom:16}}>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="6.5" stroke="#4A7C59" strokeWidth="1.5"/><path d="M5 8l2 2 4-4" stroke="#4A7C59" strokeWidth="1.5" strokeLinecap="round"/></svg>
          <span style={{fontSize:12,color:'#4A7C59',fontWeight:500}}>Timesheet submitted! Your manager has been notified.</span>
        </div>
      )}

      {/* Week grid */}
      <div style={{background:'#fff',border:'1px solid #EDE6DA',borderRadius:10,overflow:'hidden',marginBottom:14}}>
        <div style={{padding:'12px 16px',borderBottom:'1px solid #EDE6DA',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
          <div style={{fontFamily:'Georgia,serif',fontSize:15,fontWeight:600,color:'#2B2B2B'}}>Week of March 31 – April 6, 2025</div>
          <span style={{fontSize:10,padding:'2px 8px',borderRadius:8,fontWeight:600,background:accentBg,color:accent}}>Week 14 · Current</span>
        </div>
        <div style={{display:'grid',gridTemplateColumns:'repeat(7,1fr)'}}>
          {days.map((d, i) => (
            <div key={i} style={{borderRight:i<6?'1px solid #EDE6DA':'none',display:'flex',flexDirection:'column'}}>
              <div style={{padding:'8px 6px',textAlign:'center',borderBottom:'1px solid #EDE6DA',background:'#F7F2EB'}}>
                <div style={{fontSize:9,textTransform:'uppercase',letterSpacing:'0.08em',color:'#6B7D6B',fontWeight:600}}>{d.name}</div>
                <div style={{fontSize:13,color:d.date==='2'?accent:'#2B2B2B',fontWeight:d.date==='2'?700:500,marginTop:2}}>{d.date}</div>
              </div>
              <div style={{padding:'8px 6px',flex:1}}>
                {d.off ? (
                  <div style={{textAlign:'center',fontSize:10,color:'#8A9E8A',padding:'8px 0'}}>Off</div>
                ) : (
                  <div style={{display:'flex',flexDirection:'column',gap:4}}>
                    <div style={{fontSize:9,color:'#8A9E8A',textAlign:'center'}}>In</div>
                    <input defaultValue={d.clockIn} placeholder="--:--" style={{width:'100%',padding:'4px 6px',border:'1px solid #EDE6DA',borderRadius:4,fontSize:11,textAlign:'center',fontFamily:"'Montserrat',sans-serif",outline:'none'}}/>
                    <div style={{fontSize:9,color:'#8A9E8A',textAlign:'center',marginTop:2}}>Out</div>
                    <input defaultValue={d.clockOut} placeholder="--:--" style={{width:'100%',padding:'4px 6px',border:'1px solid #EDE6DA',borderRadius:4,fontSize:11,textAlign:'center',fontFamily:"'Montserrat',sans-serif",outline:'none'}}/>
                  </div>
                )}
              </div>
              <div style={{padding:'6px',textAlign:'center',borderTop:'1px solid #EDE6DA',fontSize:11,fontWeight:600,color:d.off?'#8A9E8A':accent}}>
                {d.off ? '—' : d.hours ? d.hours.toFixed(1)+'h' : '—'}
              </div>
            </div>
          ))}
        </div>
        <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',padding:'12px 16px',background:'#F7F2EB',borderTop:'1px solid #EDE6DA'}}>
          <div style={{display:'flex',gap:24}}>
            {[['Regular',regular.toFixed(1)],['Overtime',overtime.toFixed(1)],['PTO','0.0'],['Total',total.toFixed(1)]].map(([l,v]) => (
              <div key={l} style={{textAlign:'center'}}>
                <div style={{fontSize:9,textTransform:'uppercase',letterSpacing:'0.08em',color:'#6B7D6B'}}>{l}</div>
                <div style={{fontFamily:'Georgia,serif',fontSize:'1.1rem',color:l==='Total'&&total>=40?'#4A7C59':'#2B2B2B',fontWeight:600}}>{v}</div>
              </div>
            ))}
          </div>
          <button
            onClick={() => setSubmitted(true)}
            disabled={submitted}
            style={{padding:'8px 20px',background:submitted?'#8A9E8A':accent,border:'none',borderRadius:6,color:'#fff',fontSize:12,fontWeight:600,cursor:submitted?'default':'pointer',fontFamily:"'Montserrat',sans-serif"}}>
            {submitted ? 'Submitted ✓' : 'Submit Timesheet →'}
          </button>
        </div>
      </div>
    </div>
  )
}

